import { PureComponent } from "react"

import { Picker } from "emoji-mart"
import "emoji-mart/css/emoji-mart.css"

import debounce from "debounce"
import { Mutation, Query } from "react-apollo"
import Composer from "react-composer"
import Cta from "../../components/cta/cta"
import Head from "../../components/head-data/head-data"
import IdeasCards, { SAVE_IDEA } from "../../components/ideas/ideasCards"
import PageHeading from "../../components/page-heading/page-heading"
import SelectDropdown from "../../components/select-dropown/select-dropdown"
import TextInput from "../../components/text-input/text-input"
import "./ideas.scss"

import gql from "graphql-tag"
import ReactMarkdown from "react-markdown"
import customRendererLink from "../../utils/custom-link-renderer"
import {
  LOCAL_TOGGLE_IDEAS,
  LOCAL_TOGGLE_OVERLAY_MUTATION,
  LOCAL_TOGGLE_PREMIUM_COFOUNDER,
} from "../../apollo-state/graphql/mutations"
import { LOCAL_UI_QUERY } from "../../apollo-state/graphql/queries"
import AddUser from "../../components/add-user/add-user"
import MultiSelect from "../../components/multi-select/multiple-select-dropdown"
import PagePopup from "../../components/page-popup/page-popup"
import AddIdeaPopup from "../../components/add-idea-popup/add-idea-popup"
import SendMessage from "../../components/send-message/send-message"
import Tag from "../../components/tag/tag"
import { perPage } from "../../config"
import stage from "../../data/idea-stages.json"
import industries from "../../data/industries.json"
import { getDaysAgo } from "../../utils/date"
import Pagination from "../../components/ideas-pagination/ideas-pagination"
import { SKILL_PHRASES } from "../../data/skill-phrases"

export const USER_LOCKING_FOR_IDEAS = gql`
  query ideas(
    $skip: Int = 0
    $perPage: Int = 10
    $myId: ID
    $userId: ID
    $search: String
    $save: Boolean
    $sortBy: String
    $communityIdeas: Boolean
    $myIdeas: Boolean
    $selectedIndustryId: [ID]
    $selectedStageId: [ID]
    $shuffle: Boolean
    $neededSkillIds: [ID]
  ) {
    usersLookingForIdea(
      skip: $skip
      perPage: $perPage
      userId: $userId
      search: $search
      save: $save
      myIdeas: $myIdeas
      communityIdeas: $communityIdeas
      selectedIndustryId: $selectedIndustryId
      selectedStageId: $selectedStageId
      shuffle: $shuffle
      sortBy: $sortBy
      neededSkillIds: $neededSkillIds
    ) {
      title
      id
      elevatorPitch
      totalLikes
      totalComments
      totalSaves
      isActive
      createdBy {
        firstName
        profilePic
        id
        addedBy(where: { id: $myId }) {
          id
        }
        wantsSkills {
          itemId
        }
      }
      ideaIndustry {
        id
        itemId
        label
      }
      ideaStage {
        id
        itemId
        label
      }
      saves {
        id
        user {
          id
        }
      }
      likes {
        id
        user {
          id
        }
      }
    }
  }
`
const IDEA_COMMENTS = gql`
  query ideascomment($ideaId: ID!) {
    ideaCommentsByIdeaId(ideaId: $ideaId) {
      id
      body
      createdAt
      totalLikes
      likes {
        id
        user {
          id
        }
      }
      createdBy {
        profilePic
        firstName
        id
      }
      parent {
        id
      }
      replies {
        id
        body
        createdAt
        totalLikes
        likes {
          id
          user {
            id
          }
        }
        createdBy {
          profilePic
          firstName
          id
        }
      }
    }
  }
`

const UPDATE_IDEAS_LIKES = gql`
  mutation TOGGLE_LIKE_IDEA($ideaId: ID!) {
    toggleLikeIdea(ideaId: $ideaId) {
      id
      likes {
        id
        user {
          id
        }
      }
    }
  }
`
const TOGGLE_COMMENT_LIKES = gql`
  mutation TOGGLE_COMMENT_LIKES($commentId: ID!) {
    toggleCommentLikes(commentId: $commentId) {
      id
      totalLikes
      likes {
        id
        user {
          id
        }
      }
      replies {
        id
        totalLikes
        likes {
          id
          user {
            id
          }
        }
      }
    }
  }
`

const ADD_IDEA_COMMENT = gql`
  mutation IDEA_COMMENT($ideaId: ID!, $body: String!, $parentId: ID) {
    addIdeaComment(ideaId: $ideaId, body: $body, parentId: $parentId) {
      id
      body
      createdBy {
        firstName
      }
    }
  }
`

class IdeasCardsPage extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      popUpData: {},
      ideasData: [],
      commentsFieldId: "",
      replyComment: "",
      showFieldId: "",
      comments: "",
      isEmojiShowComment: false,
      isEmojiShowReplay: false,
      debounceSearch: "",
      showAddIdea: false,
      filters: {
        userId: "",
        search: "",
        save: false,
        sortBy: "most_active",
        myIdeas: false,
        communityIdeas: false,
        selectedIndustryId: [],
        selectedStageId: [],
        shuffle: false,
        neededSkillIds: [],
      },
    }
    this.handleSearchChange = this.handleSearchChange.bind(this)
    this.updateDebouncedSearch = debounce((newSearchValue) => {
      this.setState({ debouncedSearch: newSearchValue })
    }, 1000)
  }

  updateValue = ({ forLabel, value }) => {
    this.setState(
      (p) => ({
        ...p,
        filters: {
          ...p.filters,
          [forLabel]: value,
        },
      }),
      () => {
        if (forLabel === "search") {
          this.updateDebouncedSearch(value)
        }
      }
    )
  }
  handleSearchChange(evt) {
    const { value } = evt.target
    this.setState(
      (prev) => ({
        filters: {
          ...prev.filters,
          search: value,
        },
      }),
      () => {
        this.debouncedFetchIdeas()
      }
    )
  }

  setAddedStateData = (userId) => {
    this.setState((prevState) => {
      const updatedPopUpData = { ...prevState.popUpData }
      const createdBy = updatedPopUpData.createdBy || {}
      const addedBy = createdBy.addedBy || []

      const alreadyAdded = addedBy.includes(userId)
      const newAddedBy = alreadyAdded
        ? addedBy.filter((id) => id !== userId)
        : [...addedBy, userId]

      // Update popUpData
      updatedPopUpData.createdBy = {
        ...createdBy,
        addedBy: newAddedBy,
      }

      // Update ideasData
      const updatedIdeasData = prevState.ideasData.map((idea) => {
        if (idea.id === updatedPopUpData.id) {
          return {
            ...idea,
            createdBy: {
              ...idea.createdBy,
              addedBy: newAddedBy,
            },
          }
        }
        return idea
      })

      return {
        popUpData: updatedPopUpData,
        ideasData: updatedIdeasData,
      }
    })
  }
  updateIdeaSaves = (ideaId) => {
    this.setState((prev) => ({
      ideasData: prev.ideasData.map((idea) =>
        idea.id === ideaId
          ? { ...idea, saves: idea?.saves?.length ? [] : [ideaId] }
          : idea
      ),
      popUpData: {
        ...prev.popUpData,
        saves:
          prev.popUpData.id === ideaId && prev.popUpData.saves?.length
            ? []
            : [ideaId],
      },
    }))
  }
  updateIdeasLikes = (ideaId) => {
    this.setState((prev) => ({
      ideasData: prev.ideasData.map((idea) =>
        idea.id === ideaId
          ? { ...idea, likes: idea.likes?.length ? [] : [ideaId] }
          : idea
      ),
      popUpData: {
        ...prev.popUpData,

        likes:
          prev.popUpData.id === ideaId && prev.popUpData.likes?.length
            ? []
            : [ideaId],
      },
    }))
  }
  handlePopup = (newState) => {
    this.setState((p) => ({ ...p, popUpData: newState }))
  }
  showReplyField = (id) => {
    this.setState((prev) => ({
      ...prev,
      showFieldId: prev.showFieldId === id ? "" : id,
    }))
  }
  componentDidMount() {
    if (this.props.simpleCard) {
      this.setState({ ideasData: this.props.usersLookingForIdea || [] })
    }
  }

  componentDidUpdate() {
    const { simpleCard, usersLookingForIdea } = this.props
    if (simpleCard) {
      this.setState({
        ideasData: usersLookingForIdea || [],
      })
    }
  }

  resetSelection = () => {
    this.setState((p) => ({
      ...p,
      filters: {
        userId: "",
        search: "",
        save: false,
        sortBy: "most_active",
        myIdeas: false,
        communityIdeas: false,
        selectedIndustryId: [],
        selectedStageId: [],
        shuffle: false,
        neededSkillIds: [],
      },
    }))
  }
  updateMultiSelect = (selectedOptions, forLabel) => {
    this.setState({
      filters: {
        ...this.state.filters,
        [forLabel]: selectedOptions,
      },
    })
  }

  // "I can help with": one skill at a time; null shows every idea
  pickNeededSkill = (itemId) => {
    this.setState((p) => ({
      ...p,
      filters: { ...p.filters, neededSkillIds: itemId ? [itemId] : [] },
    }))
  }

  render() {
    const { me, simpleCard, sx, query } = this.props
    const neededSkill = (this.state.filters.neededSkillIds || [])[0] || null
    const pageNumber = query && query.page ? Number(query.page) : 1
    const variables = {
      skip: (pageNumber - 1) * perPage,
      perPage,
      myId: me?.id,
      ...{
        ...this.state.filters,
        selectedIndustryId:
          this.state.filters?.selectedIndustryId?.map((e) => e?.value) || [],
        selectedStageId:
          this.state.filters.selectedStageId?.map((e) => e?.value) || [],
        userId: me?.id,
        search: this.state.debouncedSearch,
      },
    }
    const isPremiumUser = me && me.hasValidCoFounderSubscription
    return (
      <div className="index">
        {!simpleCard && (
          <>
            <Head
              title="Find a Co-founder Online | App to Find Business Partners"
              description="Want to find a co-founder or business partner to launch your startup idea? Use FounderCloud's founder matcher to filter and find a co-founder across the world!"
              url="https://www.foundercloud.com/find-a-co-founder"
            />
            <PageHeading
              title="Ideas looking for co-founders"
              subHeader="Every idea here is missing someone. Maybe it&rsquo;s you."
              actions={
                <Mutation mutation={LOCAL_TOGGLE_OVERLAY_MUTATION}>
                  {(signUp) => (
                    <button
                      type="button"
                      className="ideas-top__post"
                      onClick={() => {
                        if (me?.id) {
                          this.setState({ showAddIdea: true })
                        } else {
                          signUp()
                        }
                      }}
                    >
                      Post your idea
                    </button>
                  )}
                </Mutation>
              }
            >
              <div className="ideas-top__help" role="group" aria-label="Show ideas whose founder needs">
                <span className="ideas-top__help-label">I can help with</span>
                <button
                  type="button"
                  className="ideas-top__chip"
                  aria-pressed={neededSkill === null}
                  onClick={() => this.pickNeededSkill(null)}
                >
                  Anything
                </button>
                {SKILL_PHRASES.map((skill) => (
                  <button
                    key={skill.itemId}
                    type="button"
                    className="ideas-top__chip"
                    aria-pressed={neededSkill === skill.itemId}
                    onClick={() => this.pickNeededSkill(skill.itemId)}
                  >
                    {skill.help}
                  </button>
                ))}
              </div>
            </PageHeading>
          </>
        )}
        <Composer
          components={[
            ({ render }) => <Query query={LOCAL_UI_QUERY}>{render}</Query>,
            ({ render }) => (
              <Query
                query={IDEA_COMMENTS}
                skip={!this.state?.popUpData?.id}
                variables={{
                  ideaId: this.state?.popUpData?.id,
                }}
              >
                {render}
              </Query>
            ),
            ({ render }) => (
              <Mutation
                mutation={ADD_IDEA_COMMENT}
                refetchQueries={[
                  {
                    query: IDEA_COMMENTS,
                    variables: { ideaId: this.state?.popUpData?.id },
                  },
                ]}
                onCompleted={() =>
                  this.setState({
                    commentsFieldId: "",
                    comments: "",
                    replyComment: "",
                    showFieldId: "",
                    isEmojiShowComment: false,
                    isEmojiShowReplay: false,
                  })
                }
              >
                {render}
              </Mutation>
            ),
            ({ render }) => {
              if (simpleCard) {
                return render({
                  data: { usersLookingForIdea: this.state.ideasData },
                })
              }
              return (
                <Query
                  query={USER_LOCKING_FOR_IDEAS}
                  variables={variables}
                  fetchPolicy="network-only"
                  onCompleted={({ usersLookingForIdea }) =>
                    this.setState((p) => ({
                      ...p,
                      ideasData: usersLookingForIdea,
                    }))
                  }
                  notifyOnNetworkStatusChange={true}
                >
                  {render}
                </Query>
              )
            },
            ({ render }) => (
              <Mutation
                mutation={LOCAL_TOGGLE_PREMIUM_COFOUNDER}
                variables={{ message: null }}
              >
                {render}
              </Mutation>
            ),
          ]}
        >
          {([
            uiState,
            {
              data: { ideaCommentsByIdeaId: comments} = {},
              loading: commentsLoading,
            },
            addIdeaComment,
            { data: { usersLookingForIdea } = {}, loading },
            togglePremiumCofounder,
          ]) => {
            return (
              <>
                {!simpleCard && (
                  <div className="page__grid">
                    <div
                      className="ideas-grid__filters-button mB-48"
                      style={{ marginLeft: "auto" }}
                    >
                      <Mutation mutation={LOCAL_TOGGLE_OVERLAY_MUTATION}>
                        {(signUp) => (
                          <>
                            <Cta
                              modifierClass="customeSaveBtn"
                              commanBtnclass="customestyleBtn"
                              className={
                                this.state.filters.save
                                  ? "active-save__btn"
                                  : "customectabutton"
                              }
                              onClick={() => {
                                if (me?.id) {
                                  this.setState((p) => ({
                                    ...p,
                                    filters: {
                                      ...p.filters,
                                      save: !this.state.filters.save,
                                    },
                                  }))
                                } else {
                                  signUp()
                                }
                              }}
                              type="button"
                              tag="button"
                              label="Filters"
                              text={
                                <>
                                  <img src="/static/icons/bookmark.svg" /> Save
                                </>
                              }
                              bgColor="white"
                            />
                            <Cta
                              modifierClass="customeSaveBtn"
                              commanBtnclass="customestyleBtn"
                              className={
                                this.state.filters.myIdeas
                                  ? "active-save__btn"
                                  : ""
                              }
                              onClick={() => {
                                if (me?.id) {
                                  this.setState((p) => ({
                                    ...p,
                                    filters: {
                                      ...p.filters,
                                      myIdeas: !this.state.filters.myIdeas,
                                    },
                                  }))
                                } else {
                                  signUp()
                                }
                              }}
                              type="button"
                              tag="button"
                              text={
                                <>
                                  <img src="/static/icons/group.svg" /> My ideas
                                </>
                              }
                              bgColor="white"
                            />{" "}
                            {/* <Cta
                                className={
                                  this.state.filters.communityIdeas
                                    ? "active-save__btn"
                                    : ""
                                }
                                onClick={() => {
                                  if (me?.id) {
                                    this.setState((p) => ({
                                      ...p,
                                      filters: {
                                        ...p.filters,
                                        communityIdeas:
                                          !this.state.filters.communityIdeas,
                                      },
                                    }))
                                  } else {
                                    signUp()
                                  }
                                }}
                                type="button"
                                tag="button"
                                text={
                                  <>
                                    <img src="/static/icons/persons.svg" />{" "}
                                    Community ideas
                                  </>
                                }
                                bgColor="white"
                              /> */}
                          </>
                        )}
                      </Mutation>
                    </div>
                    <div
                      className="ideas-grid"
                      style={{ position: "relative" }}
                    >
                      <div className="customeSearchInput">
                        <div className="proimg">
                          <img src="/static/icons/proimg.svg" />{" "}
                          {!isPremiumUser && me?.id && (
                            <div
                              className="proonlytext"
                              style={{ cursor: "pointer" }}
                              onClick={togglePremiumCofounder}
                            >
                              (Upgrade)
                            </div>
                          )}
                        </div>
                        <TextInput
                          className="cusstomeSearchInput"
                          label="Search"
                          forLabel="search"
                          type="text"
                          updateValue={this.updateValue}
                          value={this.state.filters.search}
                          isValid={true}
                          disabled={!isPremiumUser}
                        />
                      </div>
                      <div className="v-line" />
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "10px",
                          alignItems: "center",
                          position: "relative",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            flexDirection: "column",
                          }}
                        >
                          <div>
                            <MultiSelect
                              label="Industry"
                              options={industries.industriesData.map(
                                (item) => ({
                                  value: item.itemId,
                                  label: item.label,
                                })
                              )}
                              value={this.state.filters.selectedIndustryId}
                              onChange={(val) => {
                                this.updateMultiSelect(
                                  val,
                                  "selectedIndustryId"
                                )
                              }}
                              className={`customeSelect `}
                              size={4}
                            />
                          </div>
                        </div>
                        <div>
                          <MultiSelect
                            options={stage.ideaStagesData.map((item) => ({
                              value: item.itemId,
                              label: item.label,
                            }))}
                            value={this.state.filters.selectedStageId}
                            onChange={(val) => {
                              this.updateMultiSelect(val, "selectedStageId")
                            }}
                            size={4}
                            className={`customeSelect `}
                          />
                        </div>
                        <Cta
                          onClick={() => this.resetSelection()}
                          type="button"
                          tag="button"
                          className="resetBtn"
                          text={
                            <>
                              <svg
                                stroke="currentColor"
                                fill="currentColor"
                                stroke-width="0"
                                viewBox="0 0 24 24"
                                height="1em"
                                width="1em"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fill="none"
                                  stroke-width="2"
                                  d="M20,8 C18.5974037,5.04031171 15.536972,3 12,3 C7.02943725,3 3,7.02943725 3,12 C3,16.9705627 7.02943725,21 12,21 L12,21 C16.9705627,21 21,16.9705627 21,12 M21,3 L21,9 L15,9"
                                ></path>
                              </svg>
                              <span>reset filters</span>
                            </>
                          }
                          bgColor="white"
                        />
                      </div>
                      <div className="v-line" />{" "}
                      <Cta
                        className={
                          this.state.filters.shuffle ? "active-save__btn" : ""
                        }
                        onClick={() =>
                          this.setState((p) => ({
                            ...p,
                            filters: {
                              ...p.filters,
                              shuffle: !this.state.filters.shuffle,
                            },
                          }))
                        }
                        type="button"
                        tag="button"
                        text={
                          <>
                            <img src="/static/icons/shuffl.svg" /> Shuffle
                          </>
                        }
                        bgColor="white"
                      />
                      <div>
                        <SelectDropdown
                          isIcons
                          className="customeSelect"
                          label="Sort By"
                          wrapperClassName=""
                          innerClassName="gap-2"
                          labelWrapperClassName="customelabeltext"
                          flexWrapperClassName="ml-4"
                          selectedWrapperClassName=""
                          buttonClassName="customeimg"
                          listWrapperClassName=""
                          staticWrapperClassName=""
                          staticValueClassName=""
                          staticEditClassName=""
                          editButtonClassName=""
                          options={[
                            {
                              itemId: "most_active",
                              label: "Most Active",
                            },
                            {
                              itemId: "most_recent",
                              label: "Most Recent",
                            },
                          ]}
                          forLabel="sortBy"
                          selectedOptionId={this.state.filters.sortBy}
                          onClick={this.updateValue}
                          isValid={true}
                          validationErrorMsg=""
                        />
                      </div>
                    </div>
                  </div>
                )}
                <div className="ideas-card-container">
                  <div className="ideas-list">
                    {!loading && usersLookingForIdea?.length > 0 ? (
                      usersLookingForIdea?.map((idea, idx) => (
                        <IdeasCards
                          variables={variables}
                          signedIn={true}
                          key={idx}
                          data={idea}
                          openTileId={uiState.data.ui.ideasPopup}
                          me={me}
                          popupData={this.handlePopup}
                        />
                      ))
                    ) : !loading && usersLookingForIdea?.length === 0 ? (
                      <div className="no-ideas-found">
                        <div className="no-ideas-content">
                          <img 
                            src="/static/icons/ideabulb.svg" 
                            alt="No ideas" 
                            width="48" 
                            height="48"
                            style={{ opacity: 0.3 }}
                          />
                          <h3>No Ideas Found</h3>
                          <p>Try adjusting your filters or search terms to find more startup ideas.</p>
                        </div>
                      </div>
                    ) : (
                      <div className="loading-container">
                        <div className="loading-spinner">Loading ideas...</div>
                      </div>
                    )}
                  </div>
                </div>
                {this.state.showAddIdea && (
                  <AddIdeaPopup
                    onClose={() => this.setState({ showAddIdea: false })}
                    refetchQueries={[
                      { query: USER_LOCKING_FOR_IDEAS, variables },
                    ]}
                  />
                )}
                {uiState.data.ui.ideasPopup && (
                  <Mutation mutation={LOCAL_TOGGLE_IDEAS}>
                    {(toggle) => (
                      <PagePopup
                        togglePopup={toggle}
                        modifierClass="customeQuickViewmodal"
                        className="custom-popup-style"
                      >
                        <div className="idea-popup">
                          <div className="idea-popup__left">
                            <div className="idea-popup__icon">
                              <img
                                className=""
                                width={129}
                                height={106}
                                src="/static/icons/idea.svg"
                                alt="profile"
                              />
                            </div>
                            <div className="idea-popup__stats">
                              <img
                                src="/static/icons/message-dark.svg"
                                width={20}
                                height={20}
                              />
                              {this.state.popUpData.totalComments || 0}
                              <Mutation
                                mutation={UPDATE_IDEAS_LIKES}
                                onCompleted={() =>
                                  this.updateIdeasLikes(this.state.popUpData.id)
                                }
                              >
                                {(toggleSaveIdea) => (
                                  <>
                                    <img
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        if (me?.id) {
                                          toggleSaveIdea({
                                            variables: {
                                              ideaId: this.state.popUpData.id,
                                            },
                                          })
                                        }
                                      }}
                                      src={`${
                                        this.state?.popUpData?.likes?.length > 0
                                          ? "/static/icons/heart-red.svg"
                                          : "/static/icons/hard.svg"
                                      }`}
                                      width={20}
                                      height={20}
                                    />
                                    {this.state.popUpData?.totalLikes || 0}
                                  </>
                                )}
                              </Mutation>
                            </div>
                            {me?.id && (
                              <Mutation
                                mutation={SAVE_IDEA}
                                onCompleted={() =>
                                  this.updateIdeaSaves(this.state.popUpData.id)
                                }
                              >
                                {(toggleSaveIdea) => (
                                  <>
                                    <Cta
                                      className={`saveButton ${
                                        this.state?.popUpData?.saves?.length > 0
                                          ? "active-save__btn"
                                          : ""
                                      }`}
                                      type="button"
                                      tag="button"
                                      text={
                                        <>
                                          <img src="/static/icons/bookmark.svg" />{" "}
                                          Save
                                        </>
                                      }
                                      onClick={() =>
                                        toggleSaveIdea({
                                          variables: {
                                            ideaId: this.state.popUpData.id,
                                          },
                                        })
                                      }
                                      bgColor="white"
                                    />
                                  </>
                                )}
                              </Mutation>
                            )}
                            <div className="idea-popup__tags">
                              {this.state.popUpData?.ideaIndustry && (
                                <Tag
                                  className="active-save__btn"
                                  key={
                                    this.state.popUpData?.ideaIndustry
                                      ?.popUpData?.id
                                  }
                                  label={
                                    this.state.popUpData?.ideaIndustry?.label
                                  }
                                  title={
                                    this.state.popUpData?.ideaIndustry?.label
                                  }
                                />
                              )}
                              {this.state.popUpData?.ideaStage && (
                                <Tag
                                  className="tag stage"
                                  key={
                                    this.state.popUpData?.ideaStage?.popUpData
                                      ?.id
                                  }
                                  label={this.state.popUpData?.ideaStage?.label}
                                  title={this.state.popUpData?.ideaStage?.label}
                                />
                              )}
                            </div>
                            <div className="idea-originator">
                              <p className="title">Idea Originator:</p>
                              <div className="profile-section">
                                <img
                                  src={
                                    this.state.popUpData?.createdBy?.profilePic
                                  }
                                  alt="Pradeep"
                                  className="profile-image"
                                />
                                {me?.id &&
                                  me?.id !==
                                    this.state?.popUpData?.createdBy?.id && (
                                    <AddUser
                                      setAddedStateData={this.setAddedStateData}
                                      userId={
                                        this.state?.popUpData?.createdBy?.id
                                      }
                                      isAlreadyAdded={
                                        this.state?.popUpData?.createdBy
                                          ?.addedBy?.length > 0
                                      }
                                      loggedInUserId={me?.id}
                                    />
                                  )}
                              </div>

                              <div className="name">
                                {this.state.popUpData?.createdBy?.firstName}
                              </div>
                              {me?.id && (
                                <SendMessage
                                  isCtaButton
                                  id={this.state.popUpData?.createdBy?.id}
                                  profilePic={
                                    this.state.popUpData?.createdBy?.profilePic
                                  }
                                  firstName={
                                    this.state.popUpData?.createdBy?.firstName
                                  }
                                  convoId={me?.id}
                                />
                              )}
                            </div>
                          </div>
                          <div className="idea-popup__right">
                            <h2 className="idea-popup__title">
                              {this.state.popUpData?.title}
                            </h2>
                            <div className="idea-popup__description">
                              <ReactMarkdown
                                source={this.state.popUpData?.elevatorPitch}
                                escapeHtml={false}
                                renderers={customRendererLink}
                              />
                            </div>
                            {Boolean(comments?.length) ? (
                              comments.map((comment) => {
                                console.log(comment?.likes)
                                return (
                                  <div>
                                    <div className="idea-popup__comments">
                                      <div className="comment">
                                        <img
                                          src={comment.createdBy?.profilePic}
                                          alt="image"
                                          className="avatar"
                                          width={53}
                                          height={53}
                                        />
                                        <div className="content">
                                          <strong className="username">
                                            {comment?.createdBy?.firstName}
                                          </strong>
                                          <p className="text">
                                            {comment?.body}
                                          </p>
                                          <div className="meta">
                                            <div>
                                              {getDaysAgo(comment.createdAt)} ·{" "}
                                            </div>
                                            {me?.id && (
                                              <span
                                                className="reply"
                                                onClick={() =>
                                                  this.showReplyField(
                                                    comment.id
                                                  )
                                                }
                                              >
                                                Reply
                                              </span>
                                            )}
                                            ·{" "}
                                            <Mutation
                                              mutation={TOGGLE_COMMENT_LIKES}
                                            >
                                              {(toggleCommentLikes) => (
                                                <span className="likes">
                                                  <img
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                    onClick={() => {
                                                      if (me?.id) {
                                                        toggleCommentLikes({
                                                          variables: {
                                                            commentId:
                                                              comment.id,
                                                          },
                                                        })
                                                      }
                                                    }}
                                                    src={`${
                                                      comment?.likes?.find(
                                                        (e) =>
                                                          e?.user?.id === me?.id
                                                      )?.id
                                                        ? "/static/icons/heart-red.svg"
                                                        : "/static/icons/hard.svg"
                                                    }`}
                                                    width={20}
                                                    height={20}
                                                  />{" "}
                                                  {comment?.totalLikes || 0}
                                                </span>
                                              )}
                                            </Mutation>
                                          </div>
                                          {this.state.showFieldId ===
                                            comment.id && (
                                            <div className="comment-box">
                                              <div
                                                style={{ position: "relative" }}
                                              >
                                                <span
                                                  onClick={() =>
                                                    this.setState({
                                                      isEmojiShowReplay:
                                                        !this.state
                                                          .isEmojiShowReplay,
                                                    })
                                                  }
                                                  className="emoji-icon"
                                                >
                                                  😊
                                                </span>
                                                <Picker
                                                  style={{
                                                    position: "absolute",
                                                    zIndex: 1000,
                                                    display: this.state
                                                      .isEmojiShowReplay
                                                      ? "block"
                                                      : "none",
                                                  }}
                                                  set="apple"
                                                  onSelect={(emoji) =>
                                                    this.setState({
                                                      replyComment:
                                                        this.state
                                                          .replyComment +
                                                        emoji.native,
                                                    })
                                                  }
                                                />
                                              </div>
                                              <input
                                                type="text"
                                                value={this.state.replyComment}
                                                onChange={(e) =>
                                                  this.setState({
                                                    replyComment:
                                                      e.target.value,
                                                    commentsFieldId:
                                                      this.state.popUpData.id,
                                                  })
                                                }
                                                placeholder="Add a comment..."
                                                className="comment-input"
                                              />
                                              <button
                                                onClick={() =>
                                                  addIdeaComment({
                                                    variables: {
                                                      ideaId:
                                                        this.state.popUpData.id,
                                                      body: this.state
                                                        .replyComment,
                                                      parentId: comment.id,
                                                    },
                                                  })
                                                }
                                                className="post-btn"
                                              >
                                                Post
                                              </button>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      {Boolean(comment.replies?.length) &&
                                        comment.replies.map((reply) => (
                                          <div className="comment reply">
                                            <img
                                              src={reply.createdBy?.profilePic}
                                              alt="image"
                                              className="avatar"
                                              width={50}
                                              height={50}
                                            />
                                            <div className="content">
                                              <strong className="username">
                                                {reply?.createdBy?.firstName}
                                              </strong>
                                              <p className="text">
                                                {reply?.body}
                                              </p>
                                              <div className="meta">
                                                <div style={{ width: "100%" }}>
                                                  {getDaysAgo(reply.createdAt)}
                                                </div>
                                                <Mutation
                                                  mutation={
                                                    TOGGLE_COMMENT_LIKES
                                                  }
                                                >
                                                  {(toggleCommentLikes) => (
                                                    <span className="likes">
                                                      <img
                                                        style={{
                                                          cursor: "pointer",
                                                        }}
                                                        onClick={() => {
                                                          if (me?.id) {
                                                            toggleCommentLikes({
                                                              variables: {
                                                                commentId:
                                                                  reply.id,
                                                              },
                                                            })
                                                          }
                                                        }}
                                                        src={`${
                                                          reply?.likes?.find(
                                                            (e) =>
                                                              e?.user?.id ===
                                                              me?.id
                                                          )?.id
                                                            ? "/static/icons/heart-red.svg"
                                                            : "/static/icons/hard.svg"
                                                        }`}
                                                        width={20}
                                                        height={20}
                                                      />{" "}
                                                      {reply?.totalLikes || 0}
                                                    </span>
                                                  )}
                                                </Mutation>
                                              </div>
                                            </div>
                                          </div>
                                        ))}
                                    </div>
                                  </div>
                                )
                              })
                            ) : !me?.id ? (
                              // the API only sends comments to members
                              <p className="idea-popup__signin">
                                Sign in to read the comments.
                              </p>
                            ) : !commentsLoading && comments?.length === 0 ? (
                              "Data not found"
                            ) : (
                              <div className="user-grid__loading" />
                            )}
                            {me?.id && (
                              <div
                                className="comment-box"
                                style={{ marginTop: "10px" }}
                              >
                                <div
                                  style={{
                                    position: "relative",
                                  }}
                                >
                                  <span
                                    onClick={() =>
                                      this.setState({
                                        isEmojiShowComment:
                                          !this.state.isEmojiShowComment,
                                      })
                                    }
                                    className="emoji-icon"
                                  >
                                    😊
                                  </span>
                                  <Picker
                                    style={{
                                      position: "absolute",
                                      zIndex: 1000,
                                      display: this.state.isEmojiShowComment
                                        ? "block"
                                        : "none",
                                    }}
                                    set="apple"
                                    onSelect={(emoji) =>
                                      this.setState({
                                        comments:
                                          this.state.comments + emoji.native,
                                      })
                                    }
                                  />
                                </div>
                                <input
                                  type="text"
                                  placeholder="Add a comment..."
                                  value={this.state.comments}
                                  onChange={(e) =>
                                    this.setState({
                                      comments: e.target.value,
                                      commentsFieldId: this.state.popUpData.id,
                                    })
                                  }
                                  className="comment-input"
                                />
                                <button
                                  onClick={() =>
                                    addIdeaComment({
                                      variables: {
                                        ideaId: this.state.popUpData.id,
                                        body: this.state.comments,
                                      },
                                    })
                                  }
                                  className="post-btn"
                                >
                                  Post
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </PagePopup>
                    )}
                  </Mutation>
                )}
                {!simpleCard && (
                  <Pagination
                    variables={variables}
                    pageNumber={pageNumber}
                    query={this.props.query}
                    usersPerPage={variables.perPage}
                    me={me}
                  />
                )}
              </>
            )
          }}
        </Composer>
      </div>
    )
  }
}

export default IdeasCardsPage
